<template>
  <div>
    <div class="query-condition">
      <el-form autoComplete="off" :model="searchForm" :rules="rules" ref="searchForm" label-width="0px" :inline="true">
        <el-form-item prop="dataYear">
          <el-select v-model="searchForm.dataYear" placeholder="请选择年" size="medium" @change="changeYear">
            <el-option v-for="item in yearList" :key="item.value" :label="item.value + ' ' + item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="dataMonth">
          <el-select v-model="searchForm.dataMonth" placeholder="请选择月" size="medium">
            <el-option v-for="item in monthList" :key="item.value" :label="item.value + ' ' + item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="search" :loading="loading">搜 索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <list-card :content="opinionList" :time="dataTime" :api="api" />
  </div>
</template>
<script>
import { setList } from '@/utils/utils'
import { getOpinionDate, getOpinionData } from '@/api/query'
import ListCard from './components/ListCard'
export default {
  components: {
    ListCard
  },
  data () {
    return {
      dataTime: '',
      api: this.$BASE_URL + '/sipf-api/v2/download/investor/opinion',
      loading: false,
      maxMonth: 12,
      minMonth: 1,
      maxYear: '',
      minYear: '',
      yearList: [],
      monthList: [],
      searchForm: {
        dataMonth: '',
        dataYear: ''
      },
      rules: {
        dataMonth: [
          { required: true, trigger: 'change', message: '请选择月' }
        ],
        dataYear: [
          { required: true, trigger: 'change', message: '请选择年' }
        ]
      },
      opinionList: []
    }
  },
  created () {
    this.getDateInfo()
  },
  methods: {
    setDate () {
      this.dataTime = this.searchForm.dataYear ? `${this.searchForm.dataYear}-${this.searchForm.dataMonth}` : ''
    },
    search () {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.setDate()
          this.getData()
        } else {
          return false
        }
      })
    },
    changeYear (val) {
      this.searchForm.dataMonth = ''
      this.monthList = []
      if (val === this.minYear) {
        this.monthList = setList(12, this.minMonth, '月')
      } else if (val === this.maxYear) {
        this.monthList = setList(this.maxMonth, 1, '月')
      } else {
        this.monthList = setList(12, 1, '月')
      }
    },
    // 获取日期范围
    getDateInfo () {
      getOpinionDate().then(response => {
        const { maxTime, minTime } = response.data
        const time1 = maxTime.split('-')
        const time2 = minTime.split('-')
        this.maxMonth = Number(time1[1])
        this.minMonth = Number(time2[1])
        this.maxYear = Number(time1[0])
        this.minYear = Number(time2[0])
        this.searchForm.dataYear = this.maxYear
        this.searchForm.dataMonth = this.maxMonth < 10 ? '0'+this.maxMonth:this.maxMonth
        this.setDate()
        this.monthList = setList(this.maxMonth, 1, '月')
        this.yearList = setList(this.maxYear, this.minYear)
        this.getData()
      }).catch(error => {
        console.log(error)
      })
    },
    getData () {
      const params = {
        dataTime: this.dataTime
      }
      this.opinionList = []
      getOpinionData(params).then(response => {
        const { data } = response
        this.opinionList = data
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.el-select{
  width: 120px;
}
</style>
